// assets
import { IconCalendarEvent } from '@tabler/icons';

const adminPages = {
	id: 'administrator',
	title: 'Admin Dashboard',
	caption: 'Admin Management',
	type: 'group',
	admin: true,
	children: [
		{
			id: 'sessions',
			title: 'Sessions Management',
			type: 'item',
			url: '/admin/sessions',
			icon: IconCalendarEvent,
			breadcrumbs: false
		}
	]
};

export default adminPages;
